import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { SeoNumberedSteps } from "@/components/seo/SeoNumberedSteps";
import { Heart } from "lucide-react";

const KomikNaWesele = () => (
  <SeoPageLayout title="Komik" titleAccent="na wesele">
    <SeoSection title="Występ komediowy na weselu">
      <p>Wesele to dzień pełen emocji, radości i miłości. Profesjonalny komik na weselu to oryginalna atrakcja, która zapewni gościom niezapomniane chwile śmiechu. Zamiast tradycyjnych konkursów weselnych, postaw na elegancki humor, który bawi zarówno rodzinę, jak i przyjaciół młodej pary.</p>
    </SeoSection>

    <SeoSection title="Jak wygląda występ komika na weselu?">
      <p>Występ na weselu to delikatna sztuka. Komik przygotowuje materiał oparty na historii pary młodej, zabawnych anegdotach i uniwersalnych żartach o małżeństwie i relacjach. Humor jest ciepły, życzliwy i nigdy nie przekracza granic dobrego smaku. Występ trwa zazwyczaj 15-30 minut i idealnie wpasowuje się w przerwę między obiadem a zabawą taneczną.</p>
    </SeoSection>

    <SeoSection title="Kiedy zamówić komika na wesele?">
      <SeoStyledList items={[
        "Jako atrakcja między obiadem a pierwszym tańcem",
        "W przerwie na tort weselny",
        "Jako zamiennik tradycyjnych konkursów i zabaw",
        "Na poprawinach - lżejsza forma rozrywki drugiego dnia"
      ]} />
    </SeoSection>

    <SeoSection title="Przygotowanie materiału weselnego">
      <SeoNumberedSteps steps={[
        { title: "Rozmowa z parą młodą", description: "Komik przeprowadza rozmowę z parą młodą lub ich bliskimi." },
        { title: "Zbieranie historii", description: "Zbiera zabawne historie, anegdoty z okresu narzeczeństwa i wspólne wspomnienia." },
        { title: "Spersonalizowany materiał", description: "Tworzy materiał, który sprawia, że każdy gość czuje się częścią historii." },
      ]} />
      <SeoHighlightBox icon={Heart}>
        To prezent, który młoda para i goście zapamiętają na lata - unikatowy występ oparty na ich wspólnej historii.
      </SeoHighlightBox>
    </SeoSection>
  </SeoPageLayout>
);

export default KomikNaWesele;
